$(function () {
    $('#processing').css('visibility', 'hidden');

    $('#loginButton').click(function () {
        $('#loginButton').hide();
        $('#processing').css('visibility', 'visible');
    });
});